import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FoliarFormData } from '../../../recommendations';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import { useForBindingId } from '../../../forBinding';

interface RequestUpdateFoliarParams {
	id: string;
	data: FoliarFormData;
}

export function useUpdateAdviceFoliar() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async ({ id, data }: RequestUpdateFoliarParams) => {
			try {
				await api.put(`/advices/foliar-application/update/${id}`, data, {
					params: { forBinding },
				});
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar recomendação de foliares');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['foliar'] });
		},

		onError: (error) => {
			console.error(
				'Erro ao atualizar recomendação de foliares:',
				getApiErrorMessage(error, 'Erro ao atualizar recomendação de foliares')
			);
		},
	});
}
